<div
    class="col-10 offset-1"
    [nbSpinner]="!(crowdsaleHelperService.crowdsaleData$ | async)?.staticPages"
    nbSpinnerStatus="basic"
    nbSpinnerSize="large"
    [ngClass]="
        !(crowdsaleHelperService.crowdsaleData$ | async)?.staticPages
            ? 'fixed-height'
            : 'auto-height'
    "
>
    <nb-tabset fullWidth>
        <nb-tab
            *ngFor="
                let page of (crowdsaleHelperService.crowdsaleData$ | async)
                    ?.staticPages
            "
            tabTitle="{{ page.title }}"
            [active]="selectedPage == page.slug"
        >
            <div [innerHtml]="page.content"></div>
        </nb-tab>
    </nb-tabset>
</div>
